import { React, useState, useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  TablePagination,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";



const DipositHistory = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [data, setData] = useState([]);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };


    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  const baseApi = api_Routes.Balance.GetBalanceHistory;
  const [history, setHistory] = useState([]);
  const [pageloading, setPageLoading] = useState(true); // State for loading
  const [selectedFilter, setSelectedFilter] = useState("all");
  const calculateDiscount = (discount, discount_type, price) => {
    const numDiscount = Number(discount) || 0;
    const numPrice = Number(price) || 0;
    switch (discount_type) {
      case "const":
        return numDiscount.toFixed(2);
      case "percentage":
        return ((numPrice * numDiscount) / 100).toFixed(2);
      default:
        return "0.00";
    }
  };
  useEffect(() => {
    ad_History();
  }, [selectedFilter]);

  const ad_History = async () => {
    setPageLoading(true); // Show loader
    setPageLoading(true);
    let url = `${baseApi}?per_page=${rowsPerPage}&page=${currentPage + 1}`;

    if (selectedFilter !== "all") {
      url += `&status=${selectedFilter}`;
    }

    const { response } = await Helper.Get({
      url,
      hasToken: true,
    });

    if (response) {
      setData(response);
      setHistory(
        response.data.data.map((history) => ({
          id: history.id,
            gateway: history.gateway,
            amount: history.amount,
          status: history.status,
            transaction_id: history.transaction_id,
            created_at: history.created_at,
            paid_at: history.paid_at,
            payable_type: history.payable_type === 'App\\Models\\User' ? 'Add Balance' : 'Pay For Service',
        }))
      );
    } else {
    }
    setPageLoading(false); // Hide loader
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(0);
    setFiltersChanged(true);
  };

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
        showCenteredPopup(error|| "Failed to download report",
            { variant: "error",
                persist: true });
      // enqueueSnackbar(error || "Failed to download report", {
      //   variant: "error",
      //     persist: true,
      //     action,
      // });
    }
  };
  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      ad_History();
    }
  }, [filtersChanged, currentPage, rowsPerPage ]);
  return (
    <>
      <Box>
        <Typography
          sx={{
            color: "#474747",
            fontSize: "24px",
            lineHeight: "30px",
            fontWeight: "600",
          }}
        >
          Payment History
        </Typography>
        <Box
            sx={{
              display: { sm: "flex", xs: "grid" },
              justifyContent:'space-between',
              gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },
              flexDirection: "row",
              gap: "10px",
              marginTop: "20px",
            }}>
        {/*<Box*/}
        {/*  sx={{*/}
        {/*    display: { sm: "flex", xs: "grid" },*/}
        {/*    gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },*/}
        {/*    flexDirection: "row",*/}
        {/*    gap: "10px",*/}
        {/*    marginTop: "20px",*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {["all", "pending", "in_progress", "complete"].map((filter) => (*/}
        {/*    <Button*/}
        {/*      key={filter}*/}
        {/*      variant={selectedFilter === filter ? "contained" : "outlined"}*/}
        {/*      sx={{*/}
        {/*        "&:hover": {*/}
        {/*          backgroundColor: "#3F78E0",*/}
        {/*          color: "white",*/}
        {/*        },*/}
        {/*        borderRadius: "5px",*/}
        {/*        border: "2px solid #3F78E0",*/}
        {/*        color: selectedFilter === filter ? "white" : "#303030",*/}
        {/*        fontSize: "14px",*/}
        {/*        fontWeight: "600",*/}
        {/*        paddingBlock: "10px",*/}
        {/*        lineHeight: "18px",*/}
        {/*        width: { sm: "130px", xs: "100%" },*/}
        {/*        backgroundColor:*/}
        {/*          selectedFilter === filter ? "#3F78E0" : "white",*/}
        {/*      }}*/}
        {/*      onClick={() => handleFilterChange(filter)}*/}
        {/*    >*/}
        {/*      {filter.replace("_", " ")}*/}
        {/*    </Button>*/}
        {/*  ))}*/}
        {/*</Box>*/}
        <Button
            key={'add'}
            variant={"contained"}
            sx={{
              "&:hover": {
                backgroundColor: "#3F78E0",
                color: "white",
              },
              borderRadius: "5px",
              border: "2px solid #3F78E0",
              color: "white",
              fontSize: "14px",
              fontWeight: "600",
              paddingBlock: "2px",
              lineHeight: "15px",
              height: "40px",
              minWidth: { sm: "130px", xs: "100%" },
              backgroundColor: "#3F78E0",
            }}
            onClick={() => navigate('/make-recharge')}
        >
          +Add Balance
        </Button>
        </Box>
        {/* Show loader when pageloading is true */}
        {pageloading && (
          <Box sx={{ width: "100%", marginTop: "10px" }}>
            <LinearProgress />
          </Box>
        )}

        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            border: "2px solid #3F78E0",
            marginTop: "20px",
          }}
        >
          { history?.length > 0 ? (
            <>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#D1DDE4",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Transaction ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                        Gateway
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                        Amount
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Status
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Type
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Created Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Paid at
                    </TableCell>

                    {/*<TableCell*/}
                    {/*  sx={{*/}
                    {/*    fontWeight: "bold",*/}
                    {/*    color: "#333333",*/}
                    {/*    textAlign: "center",*/}
                    {/*    borderInlineEnd: "1px solid #3F78E0",*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  Action*/}
                    {/*</TableCell>*/}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: "#E5EDFF",
                        borderBlock: "2px solid #3F78E0",
                      }}
                    >
                      <TableCell
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                          borderInlineEnd: "1px solid #3F78E0",
                        }}
                      >
                        {row.transaction_id}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.gateway}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        ${row.amount}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.status}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.payable_type === 'Pay For Service' ?
                            <span style={{color:'#139413'}}>{row.payable_type}</span> :
                            <span style={{color:'#d22a2a'}}>{row.payable_type}</span>
                        }
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                          {new Date(row.created_at)?.toLocaleString()}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                          {row.paid_at ? new Date(row.paid_at)?.toLocaleString() : "-"}
                      </TableCell>

                      {/*<TableCell*/}
                      {/*  sx={{*/}
                      {/*    textAlign: "center",*/}
                      {/*    color: "#333333",*/}
                      {/*    display: "flex",*/}
                      {/*    flexDirection: "row",*/}
                      {/*    justifyContent: "center",*/}
                      {/*    alignItems: "center",*/}
                      {/*    gap: "10px",*/}
                      {/*  }}*/}
                      {/*>*/}
                        {/*  <Button*/}
                        {/*      sx={{*/}
                        {/*          background: "#ECA601",*/}
                        {/*          boxShadow: `*/}
                        {/*  0px 3px 3px #00000040, */}
                        {/*  inset 0px 4px 7px #FFFFFF40*/}
                        {/*`,*/}
                        {/*          color: "white",*/}
                        {/*          borderRadius: "6px",*/}
                        {/*          width: "85px",*/}
                        {/*          fontSize: "12px",*/}
                        {/*      }}*/}
                        {/*      onClick={() =>*/}
                        {/*          navigate(*/}
                        {/*              `/dashboard/ad-history/statistic/${row?.id}`*/}
                        {/*          )*/}
                        {/*      }*/}
                        {/*  >*/}
                        {/*      Statistics*/}
                        {/*  </Button>*/}
                        {/*  <Button*/}
                        {/*      sx={{*/}
                        {/*          background: "#3F78E0",*/}
                        {/*          boxShadow: `*/}
                        {/*  0px 3px 3px #00000040, */}
                        {/*  inset 0px 4px 7px #FFFFFF40*/}
                        {/*`,*/}
                        {/*          color: "white",*/}
                        {/*          borderRadius: "6px",*/}
                        {/*          width: "85px",*/}
                        {/*          fontSize: "12px",*/}
                        {/*      }}*/}
                        {/*      onClick={() =>*/}
                        {/*          navigate(*/}
                        {/*              `/dashboard/ad-history/edit/${row?.id}`*/}
                        {/*          )*/}
                        {/*      }*/}
                        {/*  >*/}
                        {/*      Edit*/}
                        {/*  </Button>*/}
                       {/*     <Button*/}
                       {/*       sx={{*/}
                       {/*         backgroundColor: "#ECA601",*/}
                       {/*         boxShadow: `*/}
                       {/*  0px 3px 3px #00000040, */}
                       {/*  inset 0px 4px 7px #FFFFFF40*/}
                       {/*`,*/}
                       {/*         color: "white",*/}
                       {/*         borderRadius: "6px",*/}
                       {/*         width: "85px",*/}
                       {/*         fontSize: "12px",*/}
                       {/*       }}*/}
                       {/*       onClick={() => handleDownload(row?.report)}*/}
                       {/*     >*/}
                       {/*       Report*/}
                       {/*     </Button>*/}


                      {/*</TableCell>*/}
                    {/*</TableRow>*/}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className="mt-4 flex justify-center items-center">
                <TablePagination
                  page={currentPage}
                  className="mt-auto"
                  onPageChange={handlePageChange}
                  count={data.pagination?.total}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  variant="outlined"
                  shape="rounded"
                  rowsPerPageOptions={[ 25, 50,100]}
                />
              </div>
            </>
          )  : (
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      border: "1px solid #3F78E0",
                    }}
                  >
                    There are no data yet
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
};

export default DipositHistory;
